// utils/apiUtils.ts
import { TravelProfile } from '../types';

// Get driving directions from OpenRouteService
export async function getDrivingDirections(
  waypoints: Array<{lat: number, lng: number}>,
  profile: TravelProfile = 'driving-car'
): Promise<any> {
  const API_KEY = '5b3ce3597851110001cf6248a1b3e9c3e6ea4e7b9a7b8c9d0e1f2a3b4c5d6e7f';
  
  const coordinates = waypoints.map(w => `${w.lng},${w.lat}`).join('|');
  const url = `https://api.openrouteservice.org/v2/directions/${profile}?api_key=${API_KEY}&start=${waypoints[0].lng},${waypoints[0].lat}&end=${waypoints[waypoints.length-1].lng},${waypoints[waypoints.length-1].lat}`;
  
  let fullUrl = url;
  if (waypoints.length > 2) {
    const intermediates = waypoints.slice(1, -1).map(w => `${w.lng},${w.lat}`).join('|');
    fullUrl += `&intermediates=${intermediates}`;
  }
  
  try {
    const response = await fetch(fullUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching directions:', error);
    return null;
  }
}

// Search for places using Nominatim API with jsonv2 format
export async function searchPlace(query: string): Promise<any[]> {
  if (!query.trim()) return [];
  
  try {
    const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=jsonv2&limit=5&addressdetails=1`;
    const response = await fetch(url, {
      headers: {
        'User-Agent': 'RouteOptimizerApp/1.0'
      }
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error searching place:', error);
    return [];
  }
}